export const openGoogleMap = (lat: number | string, lng: number | string) => {
  window.open(
    `https://www.google.com/maps/search/?api=1&query=${lat}%2C${lng}`,
    '_blank'
  )
}
